document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const backgroundIconsAscii = document.querySelectorAll(
    ".open-source-hero .hero-icons-bg-ascii .floating-icon-ascii"
  );
  const heroIconsBgAscii = document.querySelector(
    ".open-source-hero .hero-icons-bg-ascii"
  );

  // Handle ASCII version
  if (heroIconsBgAscii && backgroundIconsAscii.length > 0) {
    const asciiIconsVisible =
      window.getComputedStyle(heroIconsBgAscii).display !== "none";

    if (asciiIconsVisible) {
      // Hero icons fade in (same pattern as normal hero icons)
      gsap.to(heroIconsBgAscii, {
        opacity: 1,
        duration: 1.5,
        ease: "power2.out",
        delay: 0.3,
      });
    }
  }

  // Typing effect on main title
  const heroTitle = document.querySelector(".open-source-hero__title");
  const heroTitleText = document.querySelector(".open-source-hero__title-text");
  const heroPrompt = document.querySelector(".open-source-hero__prompt");

  if (heroTitle && heroTitleText && heroPrompt) {
    const terminalPrompt = `
 █
 █
 █
 █
 █
 █
 █
 ░`;

    // Set the prompt immediately and ensure it stays visible
    heroPrompt.textContent = terminalPrompt;
    heroPrompt.style.visibility = "visible";
    heroPrompt.style.opacity = "1";

    // Start blinking initially
    heroPrompt.classList.add("blinking");

    const asciiGlyphs = [
      `
 ██████████
░░███░░░░███
 ░███   ░░███
 ░███    ░███
 ░███    ░███
 ░███    ███
 ██████████
░░░░░░░░░░
  `,
      `
  ███
 ░░░
 ████
░░███
 ░███
 ░███
 █████
░░░░░
  `,
      `


  █████
 ███░░
░░█████
 ░░░░███
 ██████
░░░░░░
  `,
      `


  ██████
 ███░░███
░███ ░░░
░███  ███
░░██████
 ░░░░░░
  `,
      `


  ██████
 ███░░███
░███ ░███
░███ ░███
░░██████
 ░░░░░░
  `,
      `


 █████ ████
░░███ ░███
 ░███ ░███
 ░███ ░███
 ░░████████
  ░░░░░░░░
  `,
      `


 ████████
░░███░░███
 ░███ ░░░
 ░███
 █████
░░░░░
  `,
      `


  █████
 ███░░
░░█████
 ░░░░███
 ██████
░░░░░░
  `,
      `


  ██████
 ███░░███
░███████
░███░░░
░░██████
 ░░░░░░
  `,
    ];

    // Type out each glyph one at a time
    let currentGlyphIndex = 0;
    const typingSpeed = 150;

    const typeNextGlyph = () => {
      if (currentGlyphIndex < asciiGlyphs.length) {
        // Stop blinking when typing starts
        if (currentGlyphIndex === 0) {
          heroPrompt.classList.remove("blinking");
          heroPrompt.style.opacity = "1";
        }

        const glyphSpan = document.createElement("span");
        glyphSpan.className = "open-source-hero__glyph";
        glyphSpan.textContent = asciiGlyphs[currentGlyphIndex];

        // Append the glyph to the title text container
        heroTitleText.appendChild(glyphSpan);

        currentGlyphIndex++;
        setTimeout(typeNextGlyph, typingSpeed);
      } else {
        heroPrompt.classList.add("blinking");
      }
    };

    // Start with just the prompt visible
    const initialDelay = 500;
    setTimeout(typeNextGlyph, initialDelay);
  }
});
